export const PAGES_ROUTES = {
  ErrorPage: '/error',
  LoginPage: '/login',
  AccessDenied: '/access-denied',
  ComingSoon: '/coming-soon',
  NotFound: '/not-found',
  InternalServerError: '/internal-server-error',
  AuthValidatePage: '/api/v1/auth/login',
  RootPage: '/',
  Asset: '/asset',
  Associated: ':associated',
  AssociatedAssets: 'associated-assets',
  LanguageVariants: 'language-variants',
  Contentid: ':contentid',
  HomePage: '/home',
  ManageContent: 'manage-content',
  contentCategory: ':contentCategory',
  Originals: 'manage-content/originals',
  Movies: 'manage-content/movies',
  Sports: 'manage-content/sports',
  ContentCategory: ':contentCategory',
  IndependentVODAssest: 'manage-content/independent_vod_assets',
  NonVODAssest: 'manage-content/non_vod_assets',
  RolesPage: 'manage-role',
  CreateRolePage: 'create',
  ViewEditRolePage: ':rolePageType',
  ViewTypeRolePage: 'view',
  EditTypeRolePage: 'edit',
  EditRoleId: ':roleId',
  UsersPage: 'userManagement',
  MetaMaster: 'metamaster',
  AssetsDefination: 'assets-defination',
  AttributeRepository: 'attribute-repo',
  ViewEditAttributePage: ':attributePageType',
  editAttributeId: ':attributeId',
  Reports: 'reports',
  PageTypeCreate: 'create',
  PageTypeView: 'view',
  PageTypeEdit: 'edit',
  NotFoundPage: '*',
  ManageUser: 'manage-user',
  id: ':id',
  userId: ':userId',
  ManagePolicies: 'manage-policies',
  GeoPolicy: 'geo-policy',
  geoPolicyPageType: ':geoPolicyPageType',
  geoPolicyId: ':geoPolicyId',
  EntitlementControlPolicy: 'entitlement-control-policy',
  controlPolicyPageType: ':controlPolicyPageType',
  controlPolicyId: ':controlPolicyId',
  LanguageControlPolicy: 'language-control-policy',
  assetId: ':assetId',
  Masters: 'masters',
  ManageTips: 'manage-tips',
  AffiliatePartners: 'affiliate-partners',
  ViewEditAffiliatePartnersPage: ':affiliatePartnersPageType',
  AffiliatePartnersId: ':affiliatePartnersId',
  CreateAffiliatePartnersPage: 'create',
  Languages: 'languages',
  ViewEditLanguagesPage: ':languagesPageType',
  LanguagesId: ':languagesId',
  CreateLanguagesPage: 'create',
  EntitlementPackages: 'entitlement-packages',
  ViewEditEntitlementPackagesPage: ':entitlementPackagesPageType',
  EntitlementPackagesId: ':entitlementPackagesId',
  CreateEntitlementPackagesPage: 'create',
  DownstreamPlatforms: 'downstream-platforms',
  ViewEditDownstreamPlatformsPage: ':downstreamPlatformsPageType',
  DownstreamPlatformsId: ':downstreamPlatformsId',
  CreateDownstreamPlatformsPage: 'create',
  Countries: 'countries',
  ViewEditCountriesPage: ':countriesPageType',
  CountriesId: ':countriesId',
  CreateCountriesPage: 'create',
  SystemConfiguration: 'systemConfiguration',
  PageType: ':pageType',
  SystemConfigurationPageType: ':systemConfigurationPageType',
  SystemConfigurationId: ':systemConfigurationId',
  ComparisonReports: 'reports/ComparisonReports',
  AuditLogs: 'audit-logs',
  UsersRolesLogs: 'audit-logs/user-and-role-logs',
  MasterLogs: 'audit-logs/master-logs',
  ContentLogs: 'audit-logs/content-logs',
  TranscodingLogs: 'audit-logs/transcoding-logs',
  UsersRolesLogsDetailPage: 'view',
  UsersRolesLogsDetailPageId: ':id',
  MasterLogsDetailPage: 'view',
  MasterLogsDetailPageId: ':id',
  TranscodingLogsDetailPage: 'view',
  TranscodingLogsDetailPageId: ':id',
  ContentLogsDetailPage: 'view',
  ContentLogsDetailPageId: ':id',
  DataMigrationReports: 'DataMigrationReports',
  AuditTrails: 'audit-trails',
  AuditTrailsDetailPage: 'view',
  AuditTrailsDetailPageId: ':id',
  AdvancedSearch: 'advanced-search',
  CreateSystemConfirgurationPage: 'create',
  CreateSystemConfigurationPageType: 'CreatesystemConfigurationPageType',
  SaveSearch: 'save-search',
  Partner: 'partners',
  BulkUpdateRoute: 'bulk-update/:pageType/:id',
  AllNotificationsPage: 'home/all-notifications',
}
export const PAGE_NAME = {
  HomeLabel: 'Home',
  ManageContentLabel: 'Manage Content',
  TVShows: 'TV Shows',
  Originals: 'Originals',
  Movies: 'Movies',
  Sports: 'Sports',
  Shorts: 'Shorts',
  IndependentVODAssest: 'Independent VOD Assest',
  NonVODAssest: 'Non VOD Assest',
  AssociatedAssests: 'Associated Assets',
  AuditTrailsLabel: 'Audit Trails',
  AuditTrailsViewLabel: 'Audit Trails View',

  RoleManagementLabel: 'Role Management',
  UserManagementLabel: 'User Management',

  MetaMasterLabel: 'Meta Master',
  AttributeRepoLabel: 'Attribute Repository',
  AssetDefinitionLabel: 'Asset Definition',
  MastersLabel: 'Masters',
  ManageTipsLabel: 'Manage Tips',
  partnerLabel: 'Inbound Partners',

  ManagePoliciesLabel: 'Manage Policies',
  GeoPolicyManagementLabel: 'Geo Policy Management',
  EntitlementControlPolicyLable: 'Entitlement Control Policy',
  LanguageControlPolicyLabel: 'Language Control Policy',

  AuditLogsLabel: 'Audit Logs',
  ContentLogsLabel: 'Content Logs',
  UserAndRoleLogsLabel: 'User And Role Logs',
  MastersLogsLabel: 'Masters Logs',
  TranscodingLogsLabel: 'Transcoding Logs',

  BulkOprationsLabel: 'Bulk Operations',
  BulkUpdateLabel: 'CSV Based Bulk Update',
  BulkStateChangeLabel: 'Bulk State Change',
  InteractiveBulkUpdateLabel: 'Interactive Bulk Update',
  BulkTranscodingLabel: 'Bulk Re-Transcoding',

  ReportsLabel: 'Reports',
  ManageFileLabel: 'Manage Files',

  AffiliatePartnersLabel: 'Affiliate Partner',
  LanguagesLabel: 'Language',
  EntitlementPackagesLabel: 'Entitlement Packages',
  DataMigrationReportsLabel: 'Data Migration Reports',
  DownstreamPlatformsLabel: 'Downstream Platform',
  CountriesLabel: 'Country',
  ComparisonReportsLabel: 'Comparison Reports',

  AllNotificationsPage: 'All Notifications',
}
